import { render } from "./AgentDashboardView.vue?vue&type=template&id=6c15f9b7&scoped=true"
import script from "./AgentDashboardView.vue?vue&type=script&lang=js"
export * from "./AgentDashboardView.vue?vue&type=script&lang=js"

import "./AgentDashboardView.vue?vue&type=style&index=0&id=6c15f9b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c15f9b7"]])

export default __exports__